import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutoCompleteTextBoxControl } from '../../../form-models/autocomplete-textbox-control';

@Component({
  selector: 'hb-df-auto-complete-textbox',
  templateUrl: './dynamic-auto-complete-textbox.component.html',
})
export class DynamicAutoCompleteTextboxComponent {
  @Input() control: AutoCompleteTextBoxControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();
  constructor() {}

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
